import {ORDERS_HISTORY_PATH} from "../../../routes";
import {Box, IconButton, Modal, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export function ModalCantEditOrderWhenItsNotInInitialState({open, feature}) {

    const handleConfirm = () => {
        feature.isModalCantEditOrderOpened = false;
        feature.removeOrder()
        window.location.href = ORDERS_HISTORY_PATH
    };

    const handleClose = () => {
        feature.isModalCantEditOrderOpened = false;
        feature.removeOrder()
        window.location.href = ORDERS_HISTORY_PATH
    }

    const ConfirmRedirectModal = ({open, onConfirm, onCancel}) => (
        <Modal open={open} onClose={onCancel}>
            <Box sx={{
                ...style,
                width: 450,
                p: 4,
                textAlign: 'center',
                borderRadius: '8px',
                backgroundColor: '#f9f5ee',
                "@media (max-width: 768px)": {
                    width: "95%",
                },
            }}>
                <IconButton onClick={onCancel} sx={{position: 'absolute', top: 5, right: 5}}>
                    <CloseIcon/>
                </IconButton>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{fontFamily: 'ArcherSmbd', fontWeight: 'bold', fontSize: '16px'}}
                >
                    Este pedido ya se encuentra confirmado.
                </Typography>
                <Box sx={{mt: 2, display: 'flex', justifyContent: 'space-around'}}>
                    <button
                        className="btn btn-primary btn-add-to-cart"
                        style={{
                            color: '#ffffff',
                            backgroundColor: '#c1a17d',
                            borderColor: '#c1a17d',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            padding: '8px 10px'
                        }}
                        onClick={onConfirm}
                    >
                        Ir a historial de pedidos
                    </button>
                </Box>
            </Box>
        </Modal>
    );

    return (
            <ConfirmRedirectModal
                open={open}
                onConfirm={handleConfirm}
                onCancel={handleClose}
            />
    );
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};